module.exports = __webpack_public_path__ + "static/media/brackets-curly.45685fe7.svg";